import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'

// Dùng chung nhiều màn.
const HeaderFoodOrder = ({ color = 'text', label = '', value = '' }) => {
  return (
    <Box marginBottom="18px" display="flex" justifyContent="space-between" alignItems="flex-start">
      <Typography color={color} component="h2" fontSize="2.4rem" fontWeight="600" lineHeight="3rem">
        {label}
      </Typography>
      <Typography color={color} component="div" fontSize="1.8rem" whiteSpace="nowrap">
        {value}
      </Typography>
    </Box>
  )
}

export default React.memo(HeaderFoodOrder)

HeaderFoodOrder.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
}
